// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#MemberPage-module-main > section {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

#MemberPage-module-main > section:first-of-type {
  height: 730px;
  margin: -30px -30px 0;
  align-items: center;
  justify-content: center;
  background-color: black;
  width: 100vw;
  max-width: none;
  color: white;
  text-align: center;
  padding: 0 30px;
  box-sizing: border-box;
}

#MemberPage-module-imageContainer {
  height: 200px;
  width: 200px;
  border-radius: 100%;
  flex-shrink: 0;
  background-color: black;
  overflow: hidden;
}

#MemberPage-module-imageContainer > img {
  object-fit: cover;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/MemberPage/MemberPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":["#main > section {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n#main > section:first-of-type {\n  height: 730px;\n  margin: -30px -30px 0;\n  align-items: center;\n  justify-content: center;\n  background-color: black;\n  width: 100vw;\n  max-width: none;\n  color: white;\n  text-align: center;\n  padding: 0 30px;\n  box-sizing: border-box;\n}\n\n#imageContainer {\n  height: 200px;\n  width: 200px;\n  border-radius: 100%;\n  flex-shrink: 0;\n  background-color: black;\n  overflow: hidden;\n}\n\n#imageContainer > img {\n  object-fit: cover;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `MemberPage-module-main`,
	"imageContainer": `MemberPage-module-imageContainer`
};
export default ___CSS_LOADER_EXPORT___;
